var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide"},[_c('p',{staticClass:"gl-mb-7"},[_vm._v("\n    "+_vm._s(_vm.__(
        'GitLab now has a sleek panel-based layout. Find what you need faster with centered search and all your work items conveniently positioned in the upper right.',
      ))+"\n  ")]),_vm._v(" "),_c('illustration')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }